import { useParams } from "react-router-dom";
import { Layout, Loading, usePageTitle } from "@/components/site/Layout";
import { useSite } from "@/context/SiteContext";

const TITLES = { privacy: "Privacy Policy", terms: "Terms of Service", cancellation: "Cancellation Policy", "house-rules": "House Rules" };

export default function Policy() {
  const { slug } = useParams();
  const { site } = useSite();
  const title = TITLES[slug] || "Policy";
  usePageTitle(`${title} | Garage Getaway Beaumont`);
  if (!site) return <Layout><Loading /></Layout>;
  const rules = [...site.content.house_rules, ...site.policies.extra_rules];
  const text = { privacy: site.policies.privacy, terms: site.policies.terms, cancellation: site.policies.cancellation }[slug];
  return (
    <Layout>
      <article className="px-5 py-16 sm:py-24 max-w-3xl mx-auto" data-testid={`policy-page-${slug}`}>
        <p className="eyebrow">Garage Getaway Beaumont</p>
        <h1 className="mt-3 text-4xl sm:text-5xl font-medium">{title}</h1>
        {slug === "house-rules" ? (
          <ul className="mt-8 space-y-3 list-disc pl-5">{rules.map((r, i) => <li key={i}>{r}</li>)}<li>Guests must be able to climb stairs to access the apartment.</li></ul>
        ) : (
          <div className="mt-8 whitespace-pre-line leading-relaxed text-muted-foreground">{text}</div>
        )}
      </article>
    </Layout>
  );
}
